module.exports = __webpack_public_path__ + "static/media/Icond-10.620b5d8f.svg";